import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Image from '../Image';
import styles from './Avatar.module.less';

export const avatars = {
  birdy: {
    name: 'Birdee',
    path: 'https://cdn.education.com/assets/kidframe/avatars/early/Birdee.png',
  },
  cuzcuz: {
    name: 'Cuz-Cuz',
    path: 'https://cdn.education.com/assets/kidframe/avatars/early/CuzCuz.png',
  },
  floyd: {
    name: 'Floyd',
    path: 'https://cdn.education.com/assets/kidframe/avatars/early/Floyd.png',
  },
  icecream: {
    name: 'Officer Ice Cream',
    path:
      'https://cdn.education.com/assets/kidframe/avatars/early/OfficerIceCream.png',
  },
  muggo: {
    name: 'Muggo',
    path: 'https://cdn.education.com/assets/kidframe/avatars/early/Muggo.png',
  },
  penelope: {
    name: 'Penelope',
    path:
      'https://cdn.education.com/assets/kidframe/avatars/early/Penelope.png',
  },
  roly: {
    name: 'Roly',
    path: 'https://cdn.education.com/assets/kidframe/avatars/early/Roly.png',
  },
  tutu: {
    name: 'TuTu',
    path: 'https://cdn.education.com/assets/kidframe/avatars/early/TuTu.png',
  },
};

const avatarIDMap = {
  1: 'tutu',
  2: 'penelope',
  3: 'roly',
  4: 'cuzcuz',
  5: 'muggo',
  6: 'icecream',
  7: 'floyd',
  8: 'birdy',
};

export const avatarTypes = {
  PLAYER_AVATAR: 'player',
  GROUP_AVATAR: 'group',
};

export const randomAvatar = () => {
  const variants = Object.keys(avatars);
  const i = Math.floor(Math.random() * variants.length);
  return variants[i];
};

export const avatarPath = (variant = '', type = avatarTypes.PLAYER_AVATAR) => {
  switch (type) {
    case avatarTypes.GROUP_AVATAR:
      return 0 < variant < 11
        ? `/assets/kidframe/avatars/group/${variant}.png`
        : `/assets/kidframe/avatars/group/1.png`;
    case avatarTypes.PLAYER_AVATAR:
    default:
      if (!isNaN(variant)) {
        variant = avatarIDMap[parseInt(variant)] || 'roly';
      }

      return !(variant in avatars)
        ? avatars['roly'].path
        : avatars[variant].path;
  }
};

const Avatar = ({
  variant = 'roly',
  active = false,
  onClick = function() {},
  type = avatarTypes.PLAYER_AVATAR,
  ...otherProps
}) => {
  const src = avatarPath(variant, type);

  return (
    <Image
      className={clsx(
        styles.avatar,
        active ? styles.active : styles.inactive,
        otherProps.className
      )}
      alt=""
      src={src}
      onClick={() => onClick(variant)}
    />
  );
};

Avatar.propTypes = {
  variant: PropTypes.oneOf(Object.keys(avatars)).isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

export default Avatar;
